// ------------------------------------
// FOTOS (CARROSSEL)
// ------------------------------------
$(function () {
  if ($(".seminovo-det-fotos").length) {
    const totalItens = $(".seminovo-det-foto").length;

    const cols = {
      desktop: 3,
      tablet: 2,
      mobile: 1,
    };

    // Carrossel principal
    const $carouselMain = $(".seminovo-det-fotos");
    let carouselMainOpts = {
      type: "loop",
      perPage: 3,
      perMove: 1,
      speed: 600,
      arrows: true,
      pagination: false,
      autoplay: true,
      breakpoints: {
        // Tablet
        1200: {
          type: "loop",
          perMove: 1,
          perPage: cols.tablet,
          speed: 600,
          arrows: true,
          pagination: true,
          autoplay: true,
        },
        // Mobile
        760: {
          type: "loop",
          perMove: 1,
          perPage: cols.mobile,
          speed: 600,
          arrows: true,
          pagination: true,
          autoplay: true,
        },
      },
    };
    if (totalItens === 1) {
      carouselMainOpts.type = "slide";
      carouselMainOpts.arrows = false;
      carouselMainOpts.pagination = false;
      carouselMainOpts.drag = false;
      carouselMainOpts.keyboard = false;
    }
    let carouselMain = new Splide($carouselMain[0], carouselMainOpts);

    carouselMain.mount();
  }
});

// ------------------------------------
// Zoom
// ------------------------------------
(function () {
  "use strict";
  const enableZoom =
    $(".seminovo-det-fotos").data("zoom-hover") && $(window).width() > 960;
  if (enableZoom) {
    $(".seminovo-det-foto").each(function () {
      const $el = $(this);
      const imgLg = $(this).attr("href");
      if (imgLg) {
        $el.zoom({
          url: imgLg,
        });
      }
    });
  }
})();

// ------------------------------------
// Compartilhar Anuncio
// ------------------------------------
const anuncioShare = document.querySelector(".anuncio-share");
// Verifica se está na página do Anuncio
if (anuncioShare != null) {
  const textoAnuncio = document.querySelector(".seminovo-det-texto").innerText;
  console.log(document.title);
  function compartilharPagina() {
    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          text: textoAnuncio,
          url: window.location.href,
        })
        .catch((error) => console.log("Erro ao compartilhar:", error));
    } else {
      alert("Compartilhamento não suportado neste navegador.");
    }
  }
  console.log(anuncioShare);
}
